import { useUser } from '@clerk/react';

interface AuthUser {
  sub: string;
  email: string;
  name: string | null;
}

export function useAuthUser(): AuthUser | null {
  const { isSignedIn, user } = useUser();

  if (!isSignedIn || !user) {
    return null;
  }

  return {
    sub: user.id,
    email: user.primaryEmailAddress?.emailAddress ?? '',
    name: user.fullName,
  };
}
